import { useState, useEffect } from 'react';
import apiv1 from '../api_v1';

export default function PortalActivacion() {
  const [status, setStatus] = useState('activating');
  const [error, setError]   = useState('');
  const clientId = localStorage.getItem('portal_client_id');

  useEffect(() => {
    if (!clientId) return;
    activate();
  }, []);

  const activate = async () => {
    try {
      await apiv1.post(`/activation/activate/${clientId}`);
      setStatus('done');
    } catch (err) {
      const msg = err.response?.data?.detail || '';
      if (msg.includes('already_active') || err.response?.status === 200) {
        setStatus('done');
      } else {
        setError(msg || 'Error al activar la línea');
        setStatus('error');
      }
    }
  };

  if (status === 'activating') return (
    <div style={s.container}>
      <div style={s.card}>
        <div style={s.spinner} />
        <h2 style={s.title}>Activando tu línea...</h2>
        <p style={s.sub}>Estamos configurando tu servicio VoIP</p>
      </div>
    </div>
  );

  if (status === 'error') return (
    <div style={s.container}>
      <div style={s.card}>
        <div style={{ fontSize:48, color:'#ef4444', marginBottom:'1rem' }}>✗</div>
        <h2 style={s.title}>Error de activación</h2>
        <p style={s.errorBox}>{error}</p>
        <button style={s.btn} onClick={activate}>Reintentar</button>
      </div>
    </div>
  );

  return (
    <div style={s.container}>
      <div style={s.card}>
        <div style={s.icon}>✓</div>
        <h2 style={s.title}>¡Línea activada!</h2>
        <p style={s.sub}>Tu servicio VoIP está listo para usar</p>

        <div style={s.infoBox}>
          <p style={s.infoText}>
            Nuestro equipo técnico configurará tu dispositivo con las credenciales SIP.
            Recibirás instrucciones de configuración por correo electrónico.
          </p>
          <p style={s.infoText}>
            Si tienes alguna consulta, comunícate con soporte técnico.
          </p>
        </div>

        <div style={s.steps}>
          {[
            { icon:'✓', label:'Cuenta verificada' },
            { icon:'✓', label:'Contrato firmado' },
            { icon:'✓', label:'Pago procesado' },
            { icon:'✓', label:'Línea SIP activada' },
          ].map(({ icon, label }) => (
            <div key={label} style={s.step}>
              <span style={s.stepIcon}>{icon}</span>
              <span style={s.stepLabel}>{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const s = {
  container: { minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#0a0e1a', fontFamily:'sans-serif', padding:'2rem' },
  card:      { background:'#111827', border:'1px solid #1f2937', borderRadius:12, padding:'2.5rem 2rem', width:'100%', maxWidth:480, textAlign:'center' },
  title:     { color:'#f9fafb', fontSize:22, fontWeight:600, margin:'0 0 0.5rem' },
  sub:       { color:'#9ca3af', fontSize:14, margin:'0 0 1.5rem' },
  icon:      { fontSize:52, color:'#10b981', marginBottom:'1rem' },
  spinner:   { width:48, height:48, border:'4px solid #1f2937', borderTop:'4px solid #6366f1', borderRadius:'50%', animation:'spin 1s linear infinite', margin:'0 auto 1.5rem' },
  infoBox:   { background:'#0f172a', border:'1px solid #1e293b', borderRadius:10, padding:'1.25rem', marginBottom:'1.5rem', textAlign:'left' },
  infoText:  { color:'#94a3b8', fontSize:13, margin:'0 0 0.75rem', lineHeight:1.6 },
  steps:     { display:'flex', flexDirection:'column', gap:8, marginBottom:'1.5rem' },
  step:      { display:'flex', alignItems:'center', gap:10, background:'rgba(16,185,129,0.08)', border:'1px solid rgba(16,185,129,0.2)', borderRadius:8, padding:'10px 14px' },
  stepIcon:  { color:'#10b981', fontWeight:700, fontSize:14, width:20, textAlign:'center' },
  stepLabel: { color:'#d1fae5', fontSize:13 },
  btn:       { width:'100%', padding:'0.85rem', background:'linear-gradient(135deg,#6366f1,#8b5cf6)', color:'#fff', border:'none', borderRadius:8, fontSize:15, fontWeight:600, cursor:'pointer' },
  errorBox:  { background:'#7f1d1d', color:'#fca5a5', padding:'0.75rem', borderRadius:8, marginBottom:'1rem', fontSize:13 },
};
